module.exports = __webpack_public_path__ + "static/mo06-d7a0f1511d6c6a7127c63cc3d8604ce7.png";